// shared/components/pillar-table/PillarTableBody.tsx
import React from "react";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";
import { type PillarTableSafeAny } from "shared/components/pillar-table/PillarTableSafeAny";
import PillarTableRow from "shared/components/pillar-table/row/PillarTableRow";
import { PillarTableRowContextProvider } from "shared/components/pillar-table/row/PillarTableRowContext";

const PillarTableBodyRows = <
  RowGeneric = PillarTableSafeAny,
  ExtraPropsGeneric = PillarTableSafeAny | undefined,
  InlineEditFormGeneric = PillarTableSafeAny | undefined,
>() => {
  const { virtualRows, isInfinityTable } = usePillarTableContext<
    RowGeneric,
    ExtraPropsGeneric
  >();

  return (
    <>
      {virtualRows.map((virtualRow) => {
        const rowIndex = virtualRow?.index;
        const rowValue = virtualRow?.value;

        if (!rowValue) {
          return null;
        }

        //To force a re-render of the row we put the rowValue in the key
        //This is useful when the rowValue is an object and we want to re-render the row when the object changes
        //This is a workaround for the fact that React does not re-render the row if the object reference does not change
        return (
          <PillarTableRowContextProvider
            key={`row-${rowIndex}-${JSON.stringify(rowValue)}${virtualRow?.isColumnWidthReferenceRow ? "-reference" : ""}`}
            rowIndex={rowIndex}
            initRowValue={rowValue}
            virtualRowValue={virtualRow}
          >
            <PillarTableRow<
              RowGeneric,
              ExtraPropsGeneric,
              InlineEditFormGeneric
            > />
          </PillarTableRowContextProvider>
        );
      })}
    </>
  );
};

export default PillarTableBodyRows;
